export enum ActionPermission {
  createRequisition = 1,
  viewRequisitions = 2,
  createHiringRequest = 3,
  viewHiringRequests = 4,
  viewCandidates = 5,
  manageSettings = 6,
  generateReports = 7,
  viewDashboard = 8,
  unarchiveRequisitions = 9,
  createAnnouncements = 10,
  viewAnnouncements = 11,
  createRecruitmentEvents = 12,
  viewRecruitmentEvents = 13,
  deleteRecruitmentEventApplications = 14,
  viewWebsitePopups = 15,
  createWebsitePopups = 16
}
